import inventoryCategories from './inventory-categories';
import inventoryManufacturers from './inventory-manufacturers';
import products from './products';
import rawMaterials from './raw-materials';
import services from './services';
import billOfMaterials from './bill-of-materials';
import manufacturingOrders from './manufacturing-orders';
import warehouses from './warehouses';

let messages = Object.assign({}, inventoryCategories, inventoryManufacturers, products, rawMaterials, services, billOfMaterials, manufacturingOrders, warehouses);

export default messages;
